import { HorizontalAnimation } from '@components/HorizontalAnimation/HorizontalAnimation';
export const careersPageData = {
  seo: {
    title: 'Work at Joy - WithJoy.com',
    content: 'The smarter way to plan your big day.',
  },
  allPostionsCta: 'mailto:careers@withjoy.com?subject=Interested%20in%20Joy',
  heroSectionData: {
    title: 'Come build the future of <i>together</i>.',
    body:
      'We are a software company with a mission to help the world celebrate better together. Every moment, big or small, Joy is there every step of the way.',
    cta: 'Explore Open Positions',
  },
  findYourJoy: {
    title: 'It’s also how we work.',
    body:
      'Together - It’s part of everything we do at Joy. From how we work to how we play.  Joy is a place where every team member’s voice from around the world is heard and where the best ideas win.',
    bigThings: {
      title: 'Big things start in small places.',
      body: 'Yes, we really did start in a garage, building a platform to help our co-founder’s sister plan her wedding.',
      cta: 'Read Our Founding Story',
    },
  },
  remoteTeam: <HorizontalAnimation>{
    eyebrow: 'Remote First',
    title: 'We are a tight-knit team, no matter where you choose to be.',
    body: 'Live your best life while doing your life’s best work.',
    cta: 'Explore Careers',
    animation: {
      width: 2244,
      resWidth: 1225,
      letBackground: 'careers/remote/bg-teal-gradient.svg',
      backgroundAssets: [
        {
          top: 5,
          offset: -95,
          width: 404,
          resWidth: 214,
          zIndex: 1,
          src: 'careers/remote/bg-frame.svg',
        },
        {
          offset: 160,
          resOffset: 175,
          width: 700,
          resWidth: 350,
          isLeft: true,
          zIndex: 1,
          src: 'careers/remote/bg-pill.svg',
        },
        {
          top: -75,
          resTop: -75,
          offset: 210,
          resOffset: 40,
          width: 276,
          resWidth: 200,
          zIndex: 1,
          src: 'careers/remote/bg-gradient.svg',
        },
      ],
      assets: [
        {
          offset: 341,
          resOffset: 124,
          width: 392,
          resWidth: 207,
          isRadius: true,
          src: 'careers/remote/team-office-v2.jpg',
        },
        {
          offset: -95,
          width: 392,
          resWidth: 207,
          src: 'careers/remote/evan-steven.jpg',
        },
        {
          top: -18,
          resTop: -10,
          offset: 111,
          resOffset: 100,
          width: 356,
          resWidth: 225,
          isLeft: true,
          src: 'careers/remote/demos.svg',
        },
        {
          offset: 560,
          resOffset: 365,
          width: 320,
          resWidth: 170,
          isLeft: true,
          isCircle: true,
          src: 'careers/remote/circle-pic2-v3.jpg',
        },
        {
          top: 385,
          resTop: 205,
          offset: 320,
          resOffset: 125,
          width: 310,
          resWidth: 149,
          src: 'careers/remote/nicole.svg',
        },
        {
          top: 525,
          resTop: 280,
          offset: 430,
          resOffset: 185,
          width: 215,
          resWidth: 120,
          isCircle: true,
          src: 'careers/remote/circle-coding-v3.jpg',
        },
        {
          top: 685,
          resTop: 370,
          offset: -95,
          width: 392,
          resWidth: 205,
          src: 'careers/remote/kevin.svg',
        },
        {
          top: 395,
          resTop: 235,
          offset: 132,
          resOffset: 115,
          width: 596,
          resWidth: 315,
          isLeft: true,
          src: 'careers/remote/pic-zoom.jpg',
        },
        {
          top: 25,
          resTop: 25,
          offset: 965,
          resOffset: 580,
          width: 300,
          resWidth: 150,
          isLeft: true,
          isRadius: true,
          src: 'careers/remote/post-its.jpg',
        },
        {
          top: 360,
          resTop: 210,
          offset: 775,
          resOffset: 460,
          width: 392,
          resWidth: 220,
          isLeft: true,
          isRadius: true,
          src: 'careers/remote/pic-old-office.jpg',
        },
        {
          top: 55,
          resTop: 32,
          offset: 1310,
          resOffset: 760,
          width: 156,
          resWidth: 100,
          isLeft: true,
          isCircle: true,
          src: 'careers/remote/circle-pic3-v3.jpg',
        },
        {
          top: 284,
          resTop: 165,
          offset: 1215,
          resOffset: 710,
          width: 247,
          resWidth: 150,
          isLeft: true,
          isRadius: true,
          src: 'careers/remote/team-reg-zoom-v2.jpg',
        },
      ],
      foregroundAssets: [
        {
          top: 545,
          resTop: 285,
          offset: 355,
          resOffset: 140,
          width: 20,
          resWidth: 10,
          isCircle: true,
          src: 'careers/remote/fg-circle.svg',
        },
        {
          top: 20,
          offset: 600,
          resOffset: 360,
          width: 32,
          resWidth: 16,
          isLeft: true,
          src: 'careers/remote/fg-square.svg',
        },
      ],
    },
  },
  joyTeams: {
    title: 'Many strengths, one team.',
    cta: 'Explore All Roles',
    exploreRoles: 'Explore Roles',
    getInTouch: {
      title: 'Don’t see the role you are looking for?',
      body: 'Drop us a line—we’d love to meet you.',
      cta: 'Get in Touch',
    },
    teams: [
      {
        title: 'Design',
        image: 'careers/teams/design.jpg',
      },
      {
        title: 'Product',
        image: 'careers/teams/product.jpg',
      },
      {
        title: 'Engineering',
        image: 'careers/teams/eng.jpg',
      },
      {
        title: 'Marketing',
        image: 'careers/teams/marketing.jpg',
      },
      {
        title: 'Customer Experience',
        image: 'careers/teams/cx.jpg',
      },
      {
        title: 'Merchandising',
        image: 'careers/teams/merch.jpg',
      },
    ],
  },
  ourValues: {
    eyebrow: 'Our Values',
    title: 'People > Products > Profits',
    body: 'We believe if you do right by people and focus on making useful software first, the rest will fall into place.',
    values: [
      {
        icon: 'heart',
        title: 'Leave your ego behind.',
        body: 'Remember where you started. Put people before product and product before profits.',
      },
      {
        icon: 'experiment',
        title: 'Experiment and analyze.',
        body: 'Take a data-driven approach, consistently learning from your work.',
      },
      {
        icon: 'iterate',
        title: 'Iterate and improve.',
        body: 'Be agile and biased towards action. Ship product, then improve upon it.',
      },
      {
        icon: 'talk',
        title: 'Talk to users.',
        body: 'Be customer-obsessed.  Talk to them, learn from them. They are the reason we are here.',
      },
      {
        icon: 'challenge',
        title: 'Challenge boundaries.',
        body: 'Work toward being better everyday. Learn from each other and push boundaries.',
      },
      {
        icon: 'embrace',
        title: 'Embrace differences.',
        body: 'Be open-minded. Diverse experiences and mindsets lead to a stronger team.',
      },
    ],
  },
  culture: {
    eyebrow: 'Culture',
    title: 'Do the best work of your life.',
  },
  somethingBig: {
    title: 'Build it to be meaningful.',
  },
  beAmazing: {
    title:
      '“Something I’m proud of doing here at Joy is building a product based on <i>empathy</i>. <br /><br />We want to foster a great workplace culture where people don’t feel as if they’re just clocking into work. People come in to engage with each other, to share ideas, to exchange conversation, and it’s really <i>meaningful</i> work that we do together.”',
    name: 'Kevin Tran, Frontend Software Engineer',
    perks: {
      eyebrow: 'Perks and Benefits',
      title: 'It’s not why we work, but it’s icing on the cake.',
    },
    diversity: {
      title: 'Diversity, Equity & Inclusion Pledge',
      body:
        'Diversity, equity and inclusion are part of Joy’s mission, vision, and DNA. We celebrate love in all its forms. We do not tolerate discrimination of any kind.',
      body1:
        'We vow to support and celebrate diverse couples, wedding planners and wedding vendors. We are taking action as a company to create lasting change and to do our part to ensure discrimination has no place within the wedding industry and all love is celebrated.',
    },
    perksBenefits: [
      {
        icon: 'charity',
        title: 'Competitive Comp',
        body: 'We offer generous compensation and equity packages.',
      },
      {
        icon: 'travel',
        title: 'Flexible PTO',
        body: 'Take the time you need, whatever the reason. No accruals required.',
      },
      {
        icon: 'cashfunds',
        title: 'Remote Work',
        body: 'Joy is a fully remote company. Do what you love, from where you love.',
      },
      {
        icon: 'schedule',
        title: 'Generous Holidays',
        body: 'From Federal holidays to holiday breaks, we want you to rest and recharge.',
      },
      {
        icon: 'heart',
        title: 'Insurance & Retirement',
        body: 'Consider yourself covered with medical, dental, vision, life, and disability insurance + 401k.',
      },
      {
        icon: 'event',
        title: 'Team Travel & Events',
        body: 'From team retreats to travel stipends,  we help you work together while remote.',
      },
    ],
  },
  directorOfEngineering: {
    title:
      '“The thing I like most about Joy is the <i>people</i>, without an absolute doubt. <br /> <br />There is a connectedness, a heart, and engagement that goes on top of the usual passion of problem-solving. There’s this sense of connection and deeper value, and it comes from the top down.”',
    name: 'Dan Foley, Director of Engineering',
  },
  howWeWork: {
    eyebrow: 'How We Work',
    title: 'Nothing great is made alone.',
    designTitle: 'Design isn’t just a team, it is a process we’re all a part of. ',
    designBody:
      'Joy is a design-driven product. That means that the entire team values and participates in an open and collaborative design process, from the start of a feature all the way through to testing and release. Because getting to the best solution takes everyone working together.',
    workTitle: 'We work in pods, forming close relationships across disciplines and strengths.',
    workBody:
      'Pods at Joy are like sports teams. They have their own ways of working and cultures, and they’re always evolving and iterating on their products and their process. We encourage experimentation and evolution because the best way of working is always a moving target.',
  },
  productDesigner: {
    title:
      '“Everyone is so supportive and you have the freedom to <i>explore</i> what you want to explore. <br /> <br />Everyone collaborates so well together. All ideas are heard, talked about, and sometimes even executed. It’s a very <i>collaborative</i> experience.”',
    name: 'Courtney Cross, Product Designer',
  },
  careersFooter: {
    title: 'We can’t wait to meet you.',
    cta: 'Explore Open Positions',
  },
} as const;
